<template>
  <a-select show-search
            :value="value"
            placeholder="菜单搜索"
            style="width: 200px"
            :show-arrow="false"
            :filter-option="false"
            :not-found-content="null"
            :dropdown-match-select-width="false"
            @search="handleSearch"
            @change="handleChange">
    <a-select-option v-for="menu in menuSearch" :key="menu.MENU_ID">
      <div v-html="showName(menu.fullName, menu.fullFilter)"></div>
    </a-select-option>
  </a-select>
</template>

<script>
export default {
  name: "the-menu-search",
  data() {
    this.handleSearch = this.$Dolphin.debounce(this.handleSearch, 200);
    return {
      value: undefined,
      searchReg: new RegExp(''),
      menuSearch: [],
    };
  },
  computed: {
    menuList() {
      const menuList = [];
      this.$store.state.menuList.forEach(menu => {
        if (menu.CLASS_NAME) menuList.push(menu);
      });
      return menuList;
    }
  },
  methods: {
    handleSearch(val) {
      const menuSearch = [];
      this.searchReg = val;
      const reg = new RegExp(val, 'i');
      if (!val) return this.menuSearch = menuSearch;
      this.menuList.forEach(menu => {
        reg.lastIndex = 0;
        if (reg.test(menu.fullFilter) || reg.test(menu.fullName)) {
          menuSearch.push(menu);
        }
      });
      this.menuSearch = menuSearch;
    },
    handleChange(menuId) {
      this.value = undefined;
      const menu = this.menuSearch.find(m => m.MENU_ID === menuId);
      this.menuSearch = [];
      if (menu) this.$goPath(menu);
    },
    showName(name, filter) {
      const reg = new RegExp(this.searchReg, 'ig');
      const length = this.searchReg.length;
      const nameResult = name.matchAll(reg);
      const filterResult = filter.matchAll(reg);
      let indexArr = new Set();
      let res = name;
      // 分别匹配找出所有的位置
      for (const it of nameResult) {
        indexArr.add(it.index);
      }
      for (const it of filterResult) {
        indexArr.add(it.index);
      }
      // 对照位置插入<span class="color-primary">xxx</span>
      const before = '<span class="color-primary">';
      const after = '</span>';
      let start = 0;
      for (let index of indexArr) {
        index += start;
        start += (before.length + after.length);
        res = this.addStr(index, res, before);
        res = this.addStr(index + length + before.length, res, after);
      }
      return res;
    },

    addStr(index, source, str) {
      return source.substring(0, index) + str + source.substring(index);
    },
  },
};
</script>

<style scoped>

</style>
